import { call, select } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';
import * as ListenerUtils from '../../../lib/ListenerUtils';
import Logger from '../../../tools/Logger';

import { endPremiumAccess } from './helpers';

const log = Logger.child({
  component: 'mediator/useCases/handlePremiumAccess/index',
});

export function* handlePremiumAccess() {
  const hasExpiredActivePremiumAccess = yield select(
    getInDomain('rewards.utils.hasExpiredActivePremiumAccess', false),
  );
  if (hasExpiredActivePremiumAccess) {
    log.info('ending premium access session');
    const expirationTime = yield select(
      getInDomain('rewards.utils.getPremiumAccessExpirationTime'),
    );
    const sessionStartTime = yield select(ListenerUtils.getListenerSessionStartTime);
    const hasExpiredBeforeSessionStart = expirationTime < sessionStartTime;
    yield call(endPremiumAccess, hasExpiredBeforeSessionStart);
    return;
  }
}
